export const environment = {
  production: true,
  TQR_SERVICE :  "https://api.homecinemaplus.tv/api/",
  baseUrl : "https://api.homecinemaplus.tv/",
  flix_thumb : "https://flix-thumb.homecinemaplus.tv/media/",
  flix_video : "https://flix-video.homecinemaplus.tv/media/",
  vids_thumb : "https://vids-thumb.homecinemaplus.tv/media/",
  vids_video : "https://vids-video.homecinemaplus.tv/media/",
  channel_thumb : "https://core-thumb.homecinemaplus.tv/media/channel_images/",
  profile_thumb : "https://core-thumb.homecinemaplus.tv/media/profile_images/"
};